import React from "react";
import assign from "lodash/assign";
import get from "lodash/get";
import set from "lodash/set";
import { TextField, RaisedButton, Checkbox } from "material-ui";
import { Link } from "react-router";

import config from "../config";
import Label from "./partials/label.jsx";
import SelectField from "./partials/select-field.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import UserActions from "../actions/UserActions";
import UserStore from "../stores/UserStore";

class SSO extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  componentDidMount() {
    if (this.props.location.query.token) {
      UserActions.loginWithToken(this.props.location.query.token);
    } else {
      window.location.replace(
        config.endpoint +
          "auth/sso?redirect=" +
          encodeURIComponent(window.location.href) +
          "&login_hint=" +
          ((this.props.location.state || {}).login_hint || "")
      );
    }
  }

  componentWillReceiveProps(props) {
    if (UserStore.isLoggedIn()) {
      props.history.replace(`/welcome`);
    }
  }

  render() {
    return <WorkingIndicator fullPage={true} />;
  }
}

export default connectToStores(SSO);



// WEBPACK FOOTER //
// ./src/app/components/sso.jsx